import { jsxs as s, jsx as a } from "react/jsx-runtime";
import { useState as c } from "react";
import { TabNavigation as m } from "../TabNavigation/TabNavigation.js";
import { TabContent as b } from "../TabContent/TabContent.js";
function f({ tabs: t = [], navRightSideContent: e }) {
  const [n, o] = c(t[0]);
  return /* @__PURE__ */ s("tabbed-content", { children: [
    /* @__PURE__ */ a(m, { tabs: t, onTabChanged: (r) => o(r), children: e && e }),
    /* @__PURE__ */ a(b, { content: n.content, classname: n.classname ? n.classname : null })
  ] });
}
export {
  f as TabbedContent,
  f as default
};
